import {
  Grid,
  GridItem,
  Modal,
  ModalSize,
  OHeaderFive,
  OHeaderFour,
  OHeaderThree,
  OParagraph,
  OSmallParagraph,
} from '@lifechurch/react-ion';
import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { ServiceDataMoment } from '../Analytics/Service/AnalyticsServiceGrid';
import QuoteMomentDetail from './momentDetail/QuoteMomentDetail';
import ImageMomentDetail from './momentDetail/ImageMomentDetail';
import { useTranslation } from 'react-i18next';

interface Props {
  moment: ServiceDataMoment;
  dismiss: () => void;
}

const AttributionText = styled(OSmallParagraph)`
  color: ${props => props.theme.colors.gray50};
`;

const MetricGroupGridItem = styled(GridItem)`
  border-radius: 2px;
  background-color: ${props => props.theme.colors.gray5};
  padding-inline-start: ${props => props.theme.space[5]}px;
  padding-inline-end: ${props => props.theme.space[5]}px;
`;

const PrimaryMetric = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 14px;
  padding-bottom: 14px;

  p {
    font-weight: 700;
  }
`;
const SupportingMetric = styled(PrimaryMetric)`
  border-top: 1px solid ${props => props.theme.colors.gray10};
  padding-top: 12px;
  padding-bottom: 12px;
`;

const DisplayMomentDetailsModal: FC<Props> = ({ dismiss, moment }) => {
  const { t } = useTranslation('display_moment_details_modal');

  const renderMetric = (title: string, value: string, secondary?: boolean): ReactElement => {
    return (
      <>
        {secondary ? (
          <SupportingMetric>
            <OHeaderFive>{title}</OHeaderFive>
            <OSmallParagraph>{value}</OSmallParagraph>
          </SupportingMetric>
        ) : (
          <PrimaryMetric>
            <OHeaderFour>{title}</OHeaderFour>
            <OParagraph>{value}</OParagraph>
          </PrimaryMetric>
        )}
      </>
    );
  };

  return (
    <Modal dismiss={dismiss} size={ModalSize.NARROW}>
      <OHeaderThree>{moment.title}</OHeaderThree>
      <Grid gridTemplateColumns={['1fr']} paddingBlockStart={3}>
        {moment.title === 'Quote' ? (
          <QuoteMomentDetail moment={moment} />
        ) : (
          <ImageMomentDetail moment={moment} />
        )}
        <AttributionText>{moment.attribution}</AttributionText>
        <MetricGroupGridItem gridColumn={['1']} gridRow={['auto']} marginBlockStart={5}>
          {renderMetric(t('post_time'), moment.postTime)}
        </MetricGroupGridItem>
        <MetricGroupGridItem gridColumn={['1']} gridRow={['auto']} marginBlockStart={3}>
          {renderMetric(t('impressions'), moment.impressions.toString())}
        </MetricGroupGridItem>
        <MetricGroupGridItem gridColumn={['1']} gridRow={['auto']} marginBlockStart={3}>
          <GridItem gridColumn={['1']} gridRow={['auto']}>
            {renderMetric(t('interactions'), moment.interactions.toString())}
          </GridItem>
          <GridItem gridColumn={['1']} gridRow={['auto']}>
            {renderMetric(t('likes'), moment.likes.toString(), true)}
          </GridItem>
          <GridItem gridColumn={['1']} gridRow={['auto']}>
            {renderMetric(t('shares'), moment.shares.toString(), true)}
          </GridItem>
        </MetricGroupGridItem>
      </Grid>
    </Modal>
  );
};

export default DisplayMomentDetailsModal;
